document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const variantsScript = form.querySelector('[data-variants-json]');
    const idInput = form.querySelector('[name="id"]');
    // every price on the page follows the selection: buy box AND the sticky bar
    const priceTargets = document.querySelectorAll('[data-product-price]');
    const addButton = form.querySelector('[data-add-button]');
    if (!variantsScript || !idInput) return;
    let variants = [];
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    const formatMoney = (cents) => {
      const amount = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount);
      } catch (e) {
        return '$' + amount.toFixed(2);
      }
    };
    // Same short format as the price pills ("$29", "$29.50") so the button label never flickers.
    const formatShort = (cents) => {
      const n = Number(cents || 0) / 100;
      try { return new Intl.NumberFormat('en-US', { style: 'currency', currency, minimumFractionDigits: (n % 1 ? 2 : 0) }).format(n); }
      catch (e) { return '$' + n; }
    };
    // Button labels come from the template in the page language (Nov 2026 speed fix:
    // this used to reset the label to English "Add to cart" on every option tap).
    const LBL_ADD = (addButton && addButton.getAttribute('data-label-add')) || 'Add to cart';
    const LBL_SOLD = (addButton && addButton.getAttribute('data-label-sold')) || 'Sold out';
    const setText = (el, t) => { if (el.textContent.trim() !== t) { el.textContent = t; } };

    const radios = Array.from(form.querySelectorAll('[data-option-radio]'));
    const selectedOptions = () => {
      const groups = [...new Set(radios.map(r => r.name))];
      return groups.map(name => {
        const checked = form.querySelector(`[name="${name}"]:checked`);
        return checked ? checked.value : '';
      });
    };

    const update = () => {
      const selected = selectedOptions();
      const variant = variants.find(v => JSON.stringify(v.options) === JSON.stringify(selected));
      if (!variant) return;
      idInput.value = variant.id;
      const money = formatMoney(variant.price);
      priceTargets.forEach((el) => setText(el, money));
      if (addButton) {
        addButton.disabled = !variant.available;
        setText(addButton, variant.available ? LBL_ADD + ' · ' + formatShort(variant.price) : LBL_SOLD);
      }
    };

    radios.forEach(r => r.addEventListener('change', update));
    update();
  });

  // "+ Add audio" reveals the second upload without cluttering the buy box
  document.querySelectorAll('[data-add-audio]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const row = document.getElementById(btn.getAttribute('aria-controls'));
      if (!row) return;
      const open = row.hasAttribute('hidden');
      if (open) { row.removeAttribute('hidden'); } else { row.setAttribute('hidden', ''); }
      btn.setAttribute('aria-expanded', String(open));
      btn.classList.toggle('is-open', open);
      if (open) {
        const input = row.querySelector('input[type=file]');
        if (input) input.focus();
      }
    });
  });
});
